export const config = {
    url: "https://docs.google.com/spreadsheets/d/e/2PACX-1vTiv4HtdeA9MEkT9ZAv_hCOLkHI01w8GQIilPVnKq_MkoBDItbSzJ4EpmRFwYIgejl1Wf4X5R-ODAZg/pub?gid=1820272738&single=true&output=csv",
    // title: "Virginia Tech Authors 2019-2022",
    // description: "A listing of all of the publications by Virginia Tech employees over the last 3 years",
    searchFields: ["First Name", "Last Name", "Editors", "Department", "College", "Title", "Publisher", "Year Published"],
    headers: [
		{
			key: "First Name", 
			value: "First Name",
		},
        {
			key: "Last Name", 
			value: "Last Name",
		},
        {
			key: "Editors", 
			value: "Editors",
		},
        {
			key: "Department", 
			value: "Department",
		},
        {
			key: "College", 
			value: "College",
		},
        {
			key: "Title", 
			value: "Title",
		},
        {
			key: "Publisher", 
			value: "Publisher",
		},
        {
			key: "Year Published", 
			value: "Year Published",
		},
	]
}